import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RmaIconComponent],
})
export class StarRatingComponent implements OnInit {
  @Input()
  public overallStars: number | undefined;

  @Input()
  public maxStars = 5;

  @Input()
  public allowZeroStars = false;

  @Input()
  @HostBinding('class.grey')
  public isGrey = false;

  @Input()
  @HostBinding('style.fontSize.px')
  @HostBinding('style.lineHeight.px')
  public size = 22;

  @HostBinding('title')
  public get title(): string {
    return `${this.overallStars} stars`;
  }

  public stars: number[] = [];

  public ngOnInit(): void {
    this.stars = [...new Array(this.maxStars)];
  }

  public starType(currentIndex: number, totalStars: number): 0 | 1 {
    return currentIndex < totalStars ? 1 : 0;
  }
}
